import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://cfnrwoajlbbvhxjpuizp.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNmbnJ3b2FqbGJidmh4anB1aXpwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU4Nzk3MDUsImV4cCI6MjA4MTQ1NTcwNX0.w6O6CltrT-aoAri8Bs5IO1ohUYhzx2ePmDQLCYDctz8';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// QEYD (2026-07-02 təhlükəsizlik təmizliyi): əvvəllər burada `adminCreateUser`
// funksiyası və `REACT_APP_SUPABASE_SERVICE_KEY` istinadı var idi. `REACT_APP_`
// prefiksli service-role key CRA build-ində client bundle-a sızır (iyun 2026
// super-admin insidentinin eyni səbəbi). Funksiya heç yerdən çağırılmırdı (ölü
// kod) — tam silindi ki, Vercel-də env təsadüfən qalsa belə heç nəyə bağlanmasın.
// Admin istifadəçi yaratma lazım olsa: SECURITY DEFINER RPC və ya Edge Function.
